(function () {
    const config = {
        breakpoint: 1024,
        maxLines: 3,
        selectors: {
            content: '.articleLookbook-des',
            learnMore: '.learn-more-description a',
            learnMoreDescription: '.learn-more-description'
        }
    };

    function isMobileOrTablet() {
        return window.matchMedia(`(max-width: ${config.breakpoint}px)`).matches;
    }

    function getMaxHeight(element, lines) {
        const lineHeight = parseFloat(window.getComputedStyle(element).lineHeight);
        return `${lineHeight * lines}px`;
    }

    function setupTextClamping(element) {
        element.style.maxHeight = getMaxHeight(element, config.maxLines);
        element.style.overflow = 'hidden';
    }

    function setupLearnMoreClick(element, learnMoreDescription) {
        document.querySelector(config.selectors.learnMore).addEventListener('click', () => {
            element.style.maxHeight = 'none';
            learnMoreDescription.style.display = 'none';
        });
    }

    document.addEventListener('DOMContentLoaded', () => {
        if (isMobileOrTablet()) {
            const element = document.querySelector(config.selectors.content);
            const learnMoreDescription = document.querySelector(config.selectors.learnMoreDescription);

            setupTextClamping(element);
            setupLearnMoreClick(element, learnMoreDescription);
        }
    });
})();
